import { useDispatch, useSelector } from 'react-redux';
import React, { useEffect } from 'react';
import InternalAlertFormHOC from './internalAlertFormHOC';
import { useParams } from 'react-router-dom';
import { deleteInternalAlert, getInternalAlertById } from '../../reducers/internalAlertForm';
import { patchInternalAlert } from '../../reducers/internalAlertForm';
import usePrevious from "../../hooks/usePrevious";
import { push,goBack } from 'connected-react-router'

const InternalAlertFormEditHOC = (props) => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const internalAlertForm = useSelector((state) => state.internalAlertForm);
    const prevDeleting = usePrevious(internalAlertForm.deleting);

    useEffect(() => {
        dispatch(getInternalAlertById(id));
    }, [])

    useEffect(() => {
        if(prevDeleting && !internalAlertForm.deleting &&
            internalAlertForm.response === 'Internal Alert was deleted successfully' && internalAlertForm.badResponse === ''){
                dispatch(push("/internal-alerts"));
            }
    }, [prevDeleting, internalAlertForm.deleting, internalAlertForm.response, internalAlertForm.badResponse])

    const updateInternalAlert = () => {
        var body = {
            id: id,
            solicitorFirmId: internalAlertForm.formData.solicitorFirmId,
            caseTypeId: internalAlertForm.formData.selectedCaseType,
            subCaseTypeId:
                internalAlertForm.formData.selectedSubCaseType == '' ||
                    internalAlertForm.formData.selectedSubCaseType == 0
                    ? null
                    : internalAlertForm.formData.selectedSubCaseType,
            internalAlertText: internalAlertForm.formData.internalAlertText,
            validFrom: internalAlertForm.formData.validFrom,
            validTo: internalAlertForm.formData.validTo,
        }
        dispatch(patchInternalAlert({ sendBody: body }))
    }
    const handleDeleteInternalAlert = () => {
        dispatch(deleteInternalAlert(id));
    }

    return (
        <InternalAlertFormHOC 
        isEdit={true}
        handleSubmit={updateInternalAlert} 
        handleDelete={handleDeleteInternalAlert}
        />
    )
}

export default InternalAlertFormEditHOC
